import { useState, useEffect } from 'react';
import Router from 'next/router';

const useSkeletonLoading = () => {
  const [loading, setLoading] = useState(false);
  const [previousUrl, setPreviousUrl] = useState('');

  useEffect(() => {
    const start = (url: string) => {
      setPreviousUrl(Router.asPath);
      if (url.includes('/pro/detail')) {
        setLoading(true);
      }
    };

    const end = () => {
      setLoading(false);
    };
    

    Router.events.on('routeChangeStart', start);
    Router.events.on('routeChangeComplete', end);
    Router.events.on('routeChangeError', end);

    return () => {
      Router.events.off('routeChangeStart', start);
      Router.events.off('routeChangeComplete', end);
      Router.events.off('routeChangeError', end);
    };
  }, []);

  return { loading, previousUrl };
};

export default useSkeletonLoading;
